/**
 * Created by mariushirjanu on 15/06/2020.
 */
import { Component, Input } from '@angular/core';
import { IObject } from '../../../../type_definitions/datatypes';

@Component({
  selector: 'shipping-details',
  template: `
    <h2 translate="ORDERENTRY.WEBSHOP.SHIPPED_FROM"></h2>

    <h3 translate="GA.GENERAL.BP"></h3>
 
    <div class="shipping-address col-space-top col-space-bottom">
      <location-info [location]="shopContext.bp.location"></location-info>
    </div>

    <div class="shipping-info col-space-top col-space-bottom">
      <div *ngIf="shopContext.bp?.location?.telephoneNumber">
        <span translate="GA.GENERAL.PHONE"></span>: {{shopContext.bp.location.telephoneNumber}}
      </div>
      <div *ngIf="shopContext.bp?.location?.faxNumber">
        <span translate="GA.GENERAL.FAX"></span>: {{shopContext.bp.location.faxNumber}}
      </div>
      <div *ngIf="shopContext.bp?.location?.homePage">
        <span translate="GA.GENERAL.HOMEPAGE"></span>: <a href="{{shopContext.bp.location.homePage}}">{{shopContext.bp.location.homePage}}</a>
      </div>
    </div>

    <h3 translate="GA.GENERAL.COUNTRY_MANAGER"></h3>
    <div class="shipping-contact col-space-top col-space-bottom">
      <div *ngIf="shopContext.countryManager?.name">
        {{shopContext.countryManager.name}}
      </div>
      <div *ngIf="shopContext.countryManager?.phoneNumber">
        <span translate="GA.GENERAL.PHONE"></span>: {{shopContext.countryManager.phoneNumber}}
      </div>
      <div *ngIf="shopContext.countryManager?.mobileNumber">
        <span translate="GA.GENERAL.PHONE_MOBILE"></span>: {{shopContext.countryManager.mobileNumber}}
      </div>
    </div>
  `
})
export class ShippingDetailsComponent {
  // bindings
  @Input('shopContext') public shopContext:IObject;

  constructor() {
    /***/
  }
}